import { Handle, Position } from '@xyflow/react';
import { useUnistyles } from 'react-native-unistyles';
import { Pressable, Text } from 'react-native';
import Unicon from '@/components/General/Unicon';
import BranchChip from '../edges/BranchChip';
import { FONT } from '../constants';
import { TARGET_HANDLE_ID } from '../handles';

export default function BranchStubNode({ data }) {
    const { theme } = useUnistyles();
    const {
        label, isDefault, sourceStepID, branchID, branchLabel, onAddStep, canvasPosition, basePosition, readOnly,
    } = data;

    const color = isDefault ? '#94a3b8' : '#f59e0b';

    return (
        <div style={{
            width: 108,
            borderRadius: 10,
            overflow: 'visible',
            fontFamily: FONT,
            position: 'relative',
            alignItems: 'center',
        }}>
            <Handle
                type="target"
                position={Position.Top}
                id={TARGET_HANDLE_ID}
                isConnectable={false}
                style={{
                    background: color,
                    width: 8,
                    height: 8,
                    border: '2px solid #fff',
                    top: -8,
                    left: '50%',
                    transform: 'translateX(-50%)',
                }}
            />

            <div style={{
                width: '100%',
                textAlign: 'center',
                marginTop: 12,
                marginBottom: 8,
            }}>
                <BranchChip label={label} isDefault={isDefault} />
            </div>

            {!readOnly && (
                <Pressable
                    onPress={() => onAddStep?.(sourceStepID, branchID, branchLabel, canvasPosition, basePosition)}
                    style={{
                        flexDirection: 'row',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: '100%',
                        backgroundColor: theme.colors.primaryContainer,
                        borderRadius: 8,
                        padding: 6,
                        gap: 4,
                    }}
                >
                    <Unicon name="add" size={14} colorVariant="primary" />
                    <Text style={{ fontSize: 12, color: theme.colors.primary }}>Add Step</Text>
                </Pressable>
            )}
        </div>
    );
}
